import React from 'react'
import { grey } from '@mui/material/colors';
import { Typography } from '@mui/material';

const Dashboard = () => {
  return (
    <div style={{ backgroundColor: grey[200], height: '100vh', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
      <Typography variant="h3" gutterBottom>Dashboard</Typography>
    </div>
  )
}

export default Dashboard
